/**
 * User setting keys backing the Export Image dialog — see userSettingsDefs.js
 * for defaults/types (single source of truth for the resolver).
 */
export const EXPORT_SETTINGS_KEYS = {
    width: 'umlWorkspace.exportWidth',
    height: 'umlWorkspace.exportHeight',
    paddingTop: 'umlWorkspace.exportPaddingTop',
    backgroundColor: 'umlWorkspace.exportBackgroundColor',
    transparent: 'umlWorkspace.exportTransparent',
};

/**
 * Persists one export setting — context cache + backend save, same pattern
 * as UmlCanvasToolbar.handleGridSizeChange (umlWorkspace.gridSize).
 * @param {{setSetting: (key: string, value: *) => void}} context - UserSettingsContext value (this.context in the dlg)
 * @param {string} key - one of EXPORT_SETTINGS_KEYS
 * @param {*} value
 */
export function saveExportSetting(context, key, value) {
    context.setSetting(key, value);
}

/**
 * Reads all export settings from a resolved UserSettingsContext.settings object.
 * @param {object} settings - this.context.settings in the dlg
 * @returns {{width: number, height: number, paddingTop: number, backgroundColor: string, transparent: boolean}}
 */
export function resolveExportSettings(settings) {
    return {
        width: settings[EXPORT_SETTINGS_KEYS.width],
        height: settings[EXPORT_SETTINGS_KEYS.height],
        paddingTop: settings[EXPORT_SETTINGS_KEYS.paddingTop],
        backgroundColor: settings[EXPORT_SETTINGS_KEYS.backgroundColor],
        transparent: settings[EXPORT_SETTINGS_KEYS.transparent],
    };
}
